const gbpFormatter = new Intl.NumberFormat("en-GB", {
  style: "currency",
  currency: "GBP",
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
});

/**
 * Formats monetary values consistently for TransportMate's UK companies.
 * Invalid or missing values are treated as zero unless a fallback is supplied.
 */
export function formatCurrency(value: unknown, fallback = "£0.00"): string {
  if (value === null || value === undefined || value === "") return fallback;

  const amount = typeof value === "number" ? value : Number(value);
  return Number.isFinite(amount) ? gbpFormatter.format(amount) : fallback;
}
